import { redirect } from "react-router-dom";
import { Paths } from "src/constants/paths";
import { getSupabaseSession } from "src/lib/supabase/supabaseClient";

export const authLoader = async <T>(
  dispatchQuery?: () => Promise<{ data?: T; error?: unknown }>,
): Promise<T | null | ReturnType<typeof redirect>> => {
  const session = await getSupabaseSession();

  // 1. Instant router-level redirect. No UI flashing!
  if (session == null) {
    return redirect(Paths.LOG_OUT);
  }

  // 2. If no prefetch query was provided, just authorize the route and move on
  if (!dispatchQuery) {
    return null;
  }

  // 3. If a prefetch query IS provided, execute it.
  // We don't need to manually check for 401s here anymore!
  // If this throws a 401, baseQueryWithAuthGuard will handle the logout logic.
  const { data, error } = await dispatchQuery();

  if (error != null) {
    // Safely narrow the `unknown` error type without using `any`
    if (
      typeof error === "object" &&
      "status" in error &&
      error.status === 401
    ) {
      return redirect(Paths.LOG_OUT);
    }

    // If it's another kind of error, throw it so your ErrorBoundary catches it
    throw error;
  }

  // RTK Query guarantees `data` exists if `error` is null/undefined,
  // but TypeScript needs us to handle the `undefined` possibility from our interface.
  if (data === undefined) {
    throw new Error("No data returned from endpoint");
  }

  return data;
};
